module.exports = __webpack_public_path__ + "img/ic_notification_disabled.5e390bd6.svg";